module.exports = __webpack_public_path__ + "static/WEDDING E&M-428-4f73ab15d12cb72346b134f0e4237c5a.jpg";